export class Terminal {
  public Id: number = -1;
  public Name: string = "";
  public OperatingSystem: string = "";
  public NetBiosName: string = "";
  public IPAddress: string = "";
  public Branch: number = -1;
  public Active: boolean = false;
  public TillConnected: boolean = false;
  public TillDrawerName: string = "";
  public TillDrawerId: number = -1;
  public PayPointConnected: boolean = false;
  public PayPoint: number = -1;

  public static CreateFrom(t: Terminal): Terminal {
    var terminal: Terminal = new Terminal();
    terminal.Id = t.Id;
    terminal.Name = t.Name;
    terminal.OperatingSystem = t.OperatingSystem;
    terminal.NetBiosName = t.NetBiosName;
    terminal.IPAddress = t.IPAddress;
    terminal.Branch = t.Branch;
    terminal.Active = t.Active;
    terminal.TillConnected = t.TillConnected;
    terminal.TillDrawerName = t.TillDrawerName;
    terminal.TillDrawerId = t.TillDrawerId;
    terminal.PayPointConnected = t.PayPointConnected;
    terminal.PayPoint = t.PayPoint;
    return terminal;
  }
}
